var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropOverTheBowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5C19 13.5376 16.7614 16 14 16C11.2386 16 9 13.5376 9 10.5C9 7.46243 13.0909 0 14 0C14.9091 0 19 7.46243 19 10.5Z",
    fill: "#18A7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27 18.5C27 19.3284 21.1797 21.5 14 21.5C6.8203 21.5 1 19.3284 1 18.5C1 17.6716 6.8203 17 14 17C21.1797 17 27 17.6716 27 18.5Z",
    fill: "#18A7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19C28 21.307 22.3268 29 14 29C5.67325 29 0 21.307 0 19C4.30769 20.8987 5.67325 22.4177 14 22.4177C22.3268 22.4177 25.8462 19.8861 28 19Z",
    fill: "#18A7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropOverTheBowl);
export default __webpack_public_path__ + "static/media/drop-over-the-bowl.bbc1f12ef672c8fde81cbdb4a9661a44.svg";
export { ForwardRef as ReactComponent };